import { gql } from '@apollo/client';

export const GET_PRINT_SETTINGS = gql`
  query getPrintSettings {
    getPrintSettings @rest(type: "Get Print Settings", path: "printsettings") {
      settingsId
      partitionKey
      documentPrintSettings {
        defaultFormatGroup
        formatGroups {
          id
          name
          sequence
          description
          printFormats {
            id
            printScalings {
              printFormatGroup
              printFormat
              scale
            }
          }
        }
        defaultPrintOption
        printOptions {
          id
          name
          sequence
          description
        }
        defaultPostProcessingOption
        postProcessingOptions {
          id
          name
          sequence
          description
        }
      }
      drawingPrintSettings {
        defaultFormatGroup
        formatGroups {
          id
          name
          sequence
          description
          printFormats {
            id
            printScalings {
              printFormatGroup
              printFormat
              scale
            }
          }
        }
        defaultPrintOption
        printOptions {
          id
          name
          sequence
          description
        }
        defaultPostProcessingOption
        postProcessingOptions {
          id
          name
          sequence
          description
        }
      }
      formatSettings {
        id
        pageWidth
        pageHeight
        tolerance
      }
      documentExtensions {
        name
      }
    }
  }
`;
